import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button, Row, Col, Spinner } from 'reactstrap';
import NavBar from '../NavBar/navBar';
import { analyzeSanger } from '../../actions';
import './sangerAnalysis.css';

const SangerAnalysis = () => {
    const dispatch = useDispatch();
    const [files, setFiles] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [reportHtml, setReportHtml] = useState('');

    const handleFileChange = (event) => {
        const selected = Array.from(event.target.files || []);
        setFiles(selected);
        setError('');
        setReportHtml('');
    };

    const handleAnalyze = async () => {
        if (!files.length) {
            setError('Selecione os arquivos .ab1 (Forward e Reverse de cada amostra) antes de analisar.');
            return;
        }
        setLoading(true);
        setError('');
        setReportHtml('');
        try {
            const response = await dispatch(analyzeSanger(files));
            setReportHtml(response.data);
        } catch (err) {
            const responseData = err && err.data;
            const detail = responseData && (responseData.error || responseData.detalhe);
            setError(detail || 'Não foi possível gerar o relatório. Verifique os arquivos e tente novamente.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="page-layout">
            <NavBar />
            <div className="dashboard-overview sanger-analysis-page">
                <Row className="sanger-header">
                    <Col>
                        <h2>Análise Sanger</h2>
                        <p className="sanger-subtitle">
                            Envie os arquivos .ab1 (Forward e Reverse) de cada amostra. O nome de cada
                            arquivo precisa terminar em "F" ou "R" (ou "Forward"/"Reverse") antes de
                            ".ab1" — por exemplo, "118450 F.ab1" e "118450 R.ab1" — para o sistema
                            conseguir parear as leituras de cada amostra.
                        </p>
                    </Col>
                </Row>

                <Row className="sanger-controls" data-tut="reactour__sangerUpload">
                    <Col md={12} className="sanger-upload-row">
                        <input
                            type="file"
                            accept=".ab1"
                            multiple
                            onChange={handleFileChange}
                            className="sanger-file-input"
                        />
                        <Button color="primary" onClick={handleAnalyze} disabled={loading || !files.length}>
                            {loading ? <><Spinner size="sm" /> Analisando...</> : 'Analisar'}
                        </Button>
                        {files.length > 0 &&
                            <div className="sanger-file-count">{files.length} arquivo(s) selecionado(s)</div>
                        }
                    </Col>
                </Row>

                {error &&
                    <Row><Col><div className="sanger-error">{error}</div></Col></Row>
                }

                {loading &&
                    <Row><Col>
                        <div className="sanger-loading-note">
                            Rodando o Tracy para cada amostra — pode levar alguns minutos dependendo da
                            quantidade de arquivos enviados.
                        </div>
                    </Col></Row>
                }

                {reportHtml &&
                    <iframe
                        title="Relatório Sanger"
                        className="sanger-report-frame"
                        srcDoc={reportHtml}
                    />
                }
            </div>
        </div>
    );
};

export default SangerAnalysis;
